import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/wenjuan/clocks.png'


const _withScopeId = n => (_pushScopeId("data-v-270ff70c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mod_wrap mod_set_wrap mod_c select_none",
  ref: "mediaRef"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mod_c_title" }, "轻问卷", -1))
const _hoisted_3 = { class: "cache_operate" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "创建问卷", -1))
const _hoisted_5 = { class: "cache_operate_right" }
const _hoisted_6 = { class: "select_three" }
const _hoisted_7 = { class: "liveList" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rele" }, "查看报告", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "img_w"
}, null, -1))
const _hoisted_11 = { class: "operation_box" }
const _hoisted_12 = { class: "container_pagination" }

import Crumb from '@/components/Crumb.vue';
import CDelModal from '@/components/CDelModal.vue';
import { ref, reactive } from 'vue';
import { Pagination, Switch, message, Tooltip, Table } from 'ant-design-vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
import http from '@/api/report';
import { useRoute } from 'vue-router';

type Key = ColumnProps['key'];

export default /*#__PURE__*/_defineComponent({
  __name: 'Questionnairee',
  emits: ['getComponent'],
  setup(__props, { emit }) {

const aPagination = Pagination;
const aTable = Table;
const aSwitch = Switch;
const aTooltip = Tooltip;

const route = useRoute();
const studioId = route.params.studioId; // 直播间id

// 去新建问卷、编辑问卷

const createQuest = (res: any, id: number) => {
  if (id !== 1) {
    // router.push({ name: 'questionnairee', query: { id: res.id } });
    route.query.id = res.id;
    emit('getComponent', 1);
  }
};

const columns = [
  {
    id: 0,
    title: '问卷标题',
    dataIndex: 'title',
    align: 'center',
    width: '150px',
    ellipsis: true,
    slots: {
      customRender: 'title',
    },
  },
  {
    id: 1,
    title: '立即发布',
    dataIndex: 'age',
    align: 'center',
    slots: {
      customRender: 'age',
    },
  },
  // {
  //   id: 2,
  //   title: '定时发布',
  //   dataIndex: 'release',
  //   align: 'center',
  //   slots: {
  //     customRender: 'release',
  //   },
  // },
  {
    id: 3,
    title: '功能开关',
    align: 'center',
    dataIndex: 'fun',
    slots: {
      customRender: 'fun',
    },
  },
  {
    id: 4,
    title: '操作',
    dataIndex: 'operation',
    align: 'center',
    slots: {
      customRender: 'operation',
    },
  },
  {
    id: 5,
    title: '数据统计',
    align: 'center',
    dataIndex: 'statistics',
    slots: {
      customRender: 'statistics',
    },
  },
];
const showLoading = ref<boolean>(false);
const questData: any = ref([]);
// 分页器
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '20', '30', '40', '50'], // 选项
});
// 获取表格数据
const questList = () => {
  const data = {
    studio_id: studioId,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  showLoading.value = true;
  http
    .questList({ params: data })
    .then((res) => {
      const resData = res.data.data;
      questData.value = [...resData.data];
      pageConfig.totalSize = resData.total;
      showLoading.value = false;
    })
    .catch(() => {
      showLoading.value = false;
    });
};
questList();

// 选择
const selectedRowKeys: any = ref([]);
const onSelectChange = (Keys: Key[]) => {
  selectedRowKeys.value = Keys;
};

// 删除问卷
const deleteModal = ref(false);
const openDelModal = () => {
  deleteModal.value = false;
};
const deleteQuest = () => {
  const ids: any[] = [];
  selectedRowKeys.value.map((res: number) => {
    ids.push(questData.value[res].id);
  });
  const data = {
    studio_id: studioId,
    ids: ids,
  };
  http
    .questDelete(data)
    .then((res) => {
      deleteModal.value = false;
      selectedRowKeys.value = [];
      message.success(res.data.message);
      questList();
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};

// 发布问卷
const releaseQuest = (res: any) => {
  message.destroy();
  const data = {
    studio_id: studioId,
    id: res.id,
    status: res.status == 1 ? 2 : 1, //发布、再次发布1,回收2
  };
  http
    .questStatus(data)
    .then((res) => {
      message.success(res.data.message);
      questList();
    })
    .catch((res) => {
      res.data.error ? message.error(res.data.error) : '';
    });
};

// 功能开关
const showQuest = (res: any) => {
  message.destroy();
  const data = {
    studio_id: studioId,
    id: res.id,
    show_status: res.show_status ? 1 : 0,
  };
  http
    .questShow(data)
    .then((res) => {
      message.success(res.data.message);
    })
    .finally(() => {
      questList();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

// 复制问卷
const copyQuest = (res: any) => {
  message.destroy();
  http.questCopy({ quest_id: res.id }).then((res) => {
    message.success(res.data.message);
    questList();
  });
};

const clickOut = (item: any) => {
  message.destroy();
  http
    .questionPopup({ studio_id: studioId, id: item.id })
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          class: "cache_operate_s",
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (createQuest(0, 0)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_button, {
              type: "link",
              disabled: selectedRowKeys.value.length > 0 ? false : true,
              style: _normalizeStyle({
              color: selectedRowKeys.value.length > 0 ? '#FA5555' : '#606266',
            }),
              danger: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteModal.value = true))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "mod_btn_icon",
                  "icon-class": "del"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 删除 ")
              ]),
              _: 1
            }, 8, ["disabled", "style"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(aTable), {
          loading: showLoading.value,
          "row-selection": {
          selectedRowKeys: selectedRowKeys.value,
          onChange: onSelectChange,
        },
          columns: columns,
          "data-source": questData.value,
          pagination: false,
          class: "liveList_w",
          rowKey: (record, index) => index
        }, {
          age: _withCtx(({ record }) => [
            _createElementVNode("div", {
              class: "rele",
              onClick: ($event: any) => (releaseQuest(record))
            }, _toDisplayString(record.status == 0 ? '发布' : `${record.status == 1 ? '回收' : '再次发布'}`), 9, _hoisted_8)
          ]),
          statistics: _withCtx(({ record }) => [
            _createVNode(_component_router_link, {
              to: { path: `/data_center/${_unref(studioId)}/questionnaire`, query: { id: record.id } }
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          release: _withCtx(() => [
            _hoisted_10
          ]),
          fun: _withCtx(({ record }) => [
            _createVNode(_unref(aSwitch), {
              checked: record.show_status,
              "onUpdate:checked": ($event: any) => ((record.show_status) = $event),
              checkedValue: 1,
              uncheckedValue: 0,
              onClick: ($event: any) => (showQuest(record))
            }, null, 8, ["checked", "onUpdate:checked", "onClick"])
          ]),
          operation: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(aTooltip), { title: "编辑" }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "vote_imge",
                    class: "img_text",
                    style: _normalizeStyle({
                  cursor: record.status == 1 ? 'not-allowed' : 'pointer',
                }),
                    onClick: ($event: any) => (createQuest(record, record.status))
                  }, null, 8, ["style", "onClick"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(aTooltip), { title: "弹出" }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "vote_img_list",
                    class: "img_txt",
                    onClick: ($event: any) => (clickOut(record))
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(aTooltip), { title: "复制" }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "edition",
                    onClick: ($event: any) => (copyQuest(record)),
                    class: "img_txt"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["loading", "row-selection", "data-source", "rowKey"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(aPagination), {
          "show-quick-jumper": "",
          total: pageConfig.totalSize,
          current: pageConfig.current,
          "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.current) = $event)),
          "page-size": pageConfig.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig.pageSize) = $event)),
          pageSizeOptions: pageConfig.options,
          "show-less-items": "",
          onShowSizeChange: questList,
          onChange: questList,
          "show-size-changer": "",
          class: "pagination"
        }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
      ])
    ], 512),
    _createVNode(CDelModal, {
      visible: deleteModal.value,
      centered: "",
      close: openDelModal,
      ok: deleteQuest
    }, null, 8, ["visible"])
  ], 64))
}
}

})